/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: OhY1XrkS70Ck

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import MyEvalsHeader from "../../MyEvalsHeader"; // plasmic-import: 70JWAIo687UI/component
import ServiceMessage from "../../ServiceMessage"; // plasmic-import: OnWTFNPo14Tf/component
import ErrorSection from "../../ErrorSection"; // plasmic-import: eWewIpqBvzmf/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import sty from "./PlasmicNotFound.module.css"; // plasmic-import: OhY1XrkS70Ck/css

import MagnifyingGlassIconIcon from "./icons/PlasmicIcon__MagnifyingGlassIcon"; // plasmic-import: 5hrVL4XHv_e-/icon

const emptyProxy: any = new Proxy(() => "", {
  get(_, prop) {
    return prop === Symbol.toPrimitive ? () => "" : emptyProxy;
  }
});

function wrapQueriesWithLoadingProxy($q: any): any {
  return new Proxy($q, {
    get(target, queryName) {
      const query = target[queryName];
      return !query || query.isLoading || !query.data ? emptyProxy : query;
    }
  });
}

export type PageCtx = {
  pageRoute: string;
  pagePath: string;
  params: Record<string, string | string[] | undefined>;
  query: Record<string, string | string[] | undefined>;
};

export function generateDynamicMetadata($q: any, $ctx: PageCtx) {
  return {
    title: "Not Found - MyEvaluations",

    openGraph: {
      title: "Not Found - MyEvaluations"
    },
    twitter: {
      card: "summary" as const,
      title: "Not Found - MyEvaluations"
    }
  };
}

createPlasmicElementProxy;

export type PlasmicNotFound__VariantMembers = {};
export type PlasmicNotFound__VariantsArgs = {};
type VariantPropType = keyof PlasmicNotFound__VariantsArgs;
export const PlasmicNotFound__VariantProps = new Array<VariantPropType>();

export type PlasmicNotFound__ArgsType = {};
type ArgPropType = keyof PlasmicNotFound__ArgsType;
export const PlasmicNotFound__ArgProps = new Array<ArgPropType>();

export type PlasmicNotFound__OverridesType = {
  root?: Flex__<"div">;
  myEvalsHeader?: Flex__<typeof MyEvalsHeader>;
  serviceMessage?: Flex__<typeof ServiceMessage>;
  noResultsIcon?: Flex__<"div">;
  errorSection?: Flex__<typeof ErrorSection>;
  magnifyingGlassIcon?: Flex__<"svg">;
  img?: Flex__<typeof PlasmicImg__>;
};

export interface DefaultNotFoundProps {}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicNotFound__RenderFunc(props: {
  variants: PlasmicNotFound__VariantsArgs;
  args: PlasmicNotFound__ArgsType;
  overrides: PlasmicNotFound__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const pageMetadata = generateDynamicMetadata(
    wrapQueriesWithLoadingProxy({}),
    $ctx as PageCtx
  );

  const styleTokensClassNames = _useStyleTokens();

  return (
    <React.Fragment>
      <Head>
        <meta name="twitter:card" content="summary" />
        <title key="title">{pageMetadata.title}</title>
        <meta key="og:title" property="og:title" content={pageMetadata.title} />
        <meta
          key="twitter:title"
          property="twitter:title"
          content={pageMetadata.title}
        />
      </Head>

      <style>{`
        body {
          margin: 0;
        }
      `}</style>

      <div
        data-plasmic-name={"root"}
        data-plasmic-override={overrides.root}
        data-plasmic-root={true}
        data-plasmic-for-node={forNode}
        className={classNames(
          "all",
          "root_reset_bvRZj1oZhhFBeMnkX2LkQu",
          "plasmic_default_styles",
          "plasmic_mixins",
          styleTokensClassNames,
          sty.root
        )}
      >
        <MyEvalsHeader
          data-plasmic-name={"myEvalsHeader"}
          data-plasmic-override={overrides.myEvalsHeader}
          className={classNames("__wab_instance", sty.myEvalsHeader)}
        />

        <ServiceMessage
          data-plasmic-name={"serviceMessage"}
          data-plasmic-override={overrides.serviceMessage}
          className={classNames("__wab_instance", sty.serviceMessage)}
          stretch={true}
        />

        <div
          data-plasmic-name={"noResultsIcon"}
          data-plasmic-override={overrides.noResultsIcon}
          className={classNames("all", sty.noResultsIcon)}
        />

        <ErrorSection
          data-plasmic-name={"errorSection"}
          data-plasmic-override={overrides.errorSection}
          className={classNames("__wab_instance", sty.errorSection)}
          icon={
            <MagnifyingGlassIconIcon
              data-plasmic-name={"magnifyingGlassIcon"}
              data-plasmic-override={overrides.magnifyingGlassIcon}
              className={classNames("all", sty.magnifyingGlassIcon)}
              role={"img"}
            />
          }
        />

        <PlasmicImg__
          data-plasmic-name={"img"}
          data-plasmic-override={overrides.img}
          alt={""}
          className={classNames(sty.img)}
          displayHeight={"1048px"}
          displayMaxHeight={"none"}
          displayMaxWidth={"none"}
          displayMinHeight={"0"}
          displayMinWidth={"0"}
          displayWidth={"1048px"}
          loader={"plasmic"}
          loading={"lazy"}
          src={{
            src: "https://site-assets.plasmic.app/10ffe25a9aa67f4f13ea0b1beb50390c.svg",
            fullWidth: 1048,
            fullHeight: 960
          }}
        />
      </div>
    </React.Fragment>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "myEvalsHeader",
    "serviceMessage",
    "noResultsIcon",
    "errorSection",
    "magnifyingGlassIcon",
    "img"
  ],
  myEvalsHeader: ["myEvalsHeader"],
  serviceMessage: ["serviceMessage"],
  noResultsIcon: ["noResultsIcon"],
  errorSection: ["errorSection", "magnifyingGlassIcon"],
  magnifyingGlassIcon: ["magnifyingGlassIcon"],
  img: ["img"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  myEvalsHeader: typeof MyEvalsHeader;
  serviceMessage: typeof ServiceMessage;
  noResultsIcon: "div";
  errorSection: typeof ErrorSection;
  magnifyingGlassIcon: "svg";
  img: typeof PlasmicImg__;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicNotFound__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicNotFound__VariantsArgs;
    args?: PlasmicNotFound__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicNotFound__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicNotFound__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicNotFound__ArgProps,
          internalVariantPropNames: PlasmicNotFound__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicNotFound__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicNotFound";
  } else {
    func.displayName = `PlasmicNotFound.${nodeName}`;
  }
  return func;
}

export const PlasmicNotFound = Object.assign(
  // Top-level PlasmicNotFound renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    myEvalsHeader: makeNodeComponent("myEvalsHeader"),
    serviceMessage: makeNodeComponent("serviceMessage"),
    noResultsIcon: makeNodeComponent("noResultsIcon"),
    errorSection: makeNodeComponent("errorSection"),
    magnifyingGlassIcon: makeNodeComponent("magnifyingGlassIcon"),
    img: makeNodeComponent("img"),

    // Metadata about props expected for PlasmicNotFound
    internalVariantProps: PlasmicNotFound__VariantProps,
    internalArgProps: PlasmicNotFound__ArgProps,

    pageMetadata: generateDynamicMetadata(wrapQueriesWithLoadingProxy({}), {
      pageRoute: "/not-found",
      pagePath: "/not-found",
      params: {},
      query: {}
    })
  }
);

export default PlasmicNotFound;
/* prettier-ignore-end */
